import comp from "./RolesAndPermissions";
export default comp;
